import { render, staticRenderFns } from "./ContactOptionCard.vue?vue&type=template&id=27a4a958&scoped=true&"
import script from "./ContactOptionCard.vue?vue&type=script&lang=ts&"
export * from "./ContactOptionCard.vue?vue&type=script&lang=ts&"
import style0 from "./ContactOptionCard.vue?vue&type=style&index=0&id=27a4a958&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a4a958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
